import type { CSSProperties } from 'react';

const FALLBACK_TINT = '#64748b';

/**
 * Colors of an absence label. Employees get the light tint of the absence type; the
 * administration gets the same type color as a solid fill, so both stay tellable apart
 * in one plan while the type keeps its color (FACF-94).
 */
export function absenceChipStyle(typeColor: string | null | undefined, backOffice: boolean): CSSProperties {
  const tint = typeColor || FALLBACK_TINT;
  return backOffice
    ? { backgroundColor: tint, color: '#ffffff' }
    : { backgroundColor: `${tint}20`, color: tint };
}
